import { BoxProps, tokens } from "shared/components/Spor";
import { useThemeOrSemantic } from "shared/theme/themeSemantic";
import { FCWC } from "shared/utils/FCWC";
import { Semantics } from "shared/utils/semantics";

export const SemanticBox: FCWC<
  { variant: Semantics; header?: React.ReactNode } & BoxProps
> = ({ children, variant, header }) => {
  const theme = useThemeOrSemantic(variant);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        background: theme.colorSemanticFill,
        border: `1px solid ${theme.colorSemanticOutline}`,
        borderRadius: tokens.default.size["border-radius"].sm,
        padding: tokens.default.size.spacing[2],
        color: theme.colorSemanticTextSecondary,
        gap: tokens.default.size.spacing[2],
      }}
    >
      <div style={{ color: theme.colorSemanticTextMain }}>{header}</div>
      {children}
    </div>
  );
};
